import React, { useEffect, useState } from "react";
import {
  Button,
  CircularProgress,
  Grid2,
  Stack,
  Typography,
} from "@mui/material";
import VehicleCardComponent from "components/organisms/vehicle-card/vehicle-card.component";
import "./home.css";
import { useNavigate } from "react-router-dom";
import {
  GlobalState,
  Rental,
  disableButton,
  enableButton,
  useAppDispatch,
  getAvilableCarsAction,
  store,
  Car,
  updateDates,
  updateTotals,
} from "store/rentals-store";
import { useSelector } from "react-redux";
import { Path } from "components/app.component";
import { DateRange, DateRangePicker } from "@mui/x-date-pickers-pro";
import { dateToString, getTodaysDate, DateType } from "helpers/date-utils";

export default function Home() {
  const rental: Rental = useSelector((state: GlobalState) => state.rental);
  const path: string = useSelector(
    (state: GlobalState) => state.navigation.currentPath
  );
  const availableCars: Car[] = useSelector(
    (state: GlobalState) => state.availableCars
  );
  const [showLoader, setShowLoader] = useState(false);
  const [message, setMessage] = useState("");
  const navigation = useNavigate();
  const dispatch = useAppDispatch();
  const [dateRangeValue, setDateRangeValue] = React.useState<
    DateRange<DateType>
  >([getTodaysDate(), null]);
  const searchForAvailableCars = async () => {
    const startDate = dateRangeValue[0].startOf("day");
    const endDate = dateRangeValue[1].startOf("day");
    if (startDate && endDate) {
      console.log({ startDate, endDate });
      setShowLoader(true);
      setMessage("");
      dispatch(
        updateDates({
          startDate: dateToString(startDate),
          endDate: dateToString(endDate),
        })
      );
      dispatch(
        getAvilableCarsAction({
          startDate: dateToString(startDate),
          endDate: dateToString(endDate),
        })
      );
      dispatch(updateTotals({ items: [], days: 0, amountDue: 0 }));
    }
  };

  useEffect(() => {
    if (path === Path.Contact && rental.totals?.items?.length > 0) {
      navigation(Path.Contact);
    }
  }, [path, navigation, rental.totals]);

  useEffect(() => {
    if (rental.totals?.items?.length > 0) {
      store.dispatch(enableButton());
      return;
    }

    store.dispatch(disableButton());
  }, [rental.totals]);

  useEffect(() => {
    if (availableCars?.length === 0) {
      setMessage("No hay autos disponibles");
    }
    setShowLoader(false);
  }, [availableCars]);

  /* istanbul ignore next */
  function hideUnlicensedMessage() {
    // TODO: remove this when license is purchased
    setTimeout(() => {
      const xpath = "//div[contains(text(),'MUI X Missing license key')]";
      const matchingElement = document.evaluate(
        xpath,
        document,
        null,
        XPathResult.FIRST_ORDERED_NODE_TYPE,
        null
      ).singleNodeValue as HTMLElement;
      matchingElement?.remove();
    }, 300);
  }

  return (
    <Stack spacing={2}>
      <Typography
        fontSize={{
          lg: 35,
          md: 25,
          sm: 20,
          xs: 20,
        }}
      >
        {" "}
        Reservar auto
      </Typography>
      <DateRangePicker
        onOpen={hideUnlicensedMessage}
        localeText={{ start: "Inicio", end: "Devolución" }}
        value={dateRangeValue}
        format={"DD/MM/YYYY"}
        onChange={(newDates: DateRange<DateType>) =>
          setDateRangeValue(newDates)
        }
      />
      <Button
        variant="contained"
        disabled={!(dateRangeValue[0] && dateRangeValue[1])}
        onClick={searchForAvailableCars}
      >
        Buscar autos disponibles
      </Button>
      {showLoader && (
        <Grid2 container alignItems={"center"} justifyContent={"center"}>
          <CircularProgress />
        </Grid2>
      )}
      <Grid2 container justifyContent={"center"} spacing={1}>
        {availableCars &&
          availableCars.map((car: Car) => (
            <Grid2 key={car.id} size={{ xs: 12, sm: 12, xl: 6 }}>
              <VehicleCardComponent car={car} />
            </Grid2>
          ))}
        {message}
      </Grid2>
    </Stack>
  );
}
